/* eslint-disable @typescript-eslint/naming-convention */
export enum ContactsButtonTypesEnum {
    Add,
    Edit,
    Delete
}
